// Generated from src/assets/Check.svg
import React, { PureComponent } from "react";

interface ISVGUserIconProps {
  /**
   * additional classname
   */
  // prettier-ignore
  className?: string;
  /**
   * size of the svg icon
   */
  // prettier-ignore
  size?: string | number;
  /**
   * color of the svg icon
   */
  // prettier-ignore
  fill?: string;
  /**
   * onClick event
   */
  // prettier-ignore
  onClick?: React.MouseEventHandler<SVGSVGElement>;
}

const style = {
  cursor: "pointer",
  width: "27px"
};

export default class SVGUserIcon extends PureComponent<ISVGUserIconProps, {}> {
  render() {
    const props = this.props;
    const { size, fill } = props;
    return (
      <svg
        {...props}
        preserveAspectRatio="xMidYMid meet"
        fontSize={size || 32}
        fill={fill || "currentColor"}
        style={style}
        viewBox="0 0 35 35"
        enableBackground="new 0 0 35 35"
      >
        <path
          fill="#FFFFFF"
          d="M17.5,0C7.833,0,0,7.833,0,17.5S7.833,35,17.5,35C27.166,35,35,27.167,35,17.5C35,7.832,27.166,0,17.5,0z
	 M17.5,6.773c3.43,0,6.211,2.781,6.211,6.209c0,3.43-2.781,6.209-6.211,6.209c-3.432,0-6.211-2.779-6.211-6.209
	C11.289,9.555,14.07,6.773,17.5,6.773z M17.5,31.049c-4.143,0-7.854-1.877-10.338-4.813c1.326-2.498,3.924-4.221,6.949-4.221
	c0.17,0,0.34,0.027,0.502,0.078c0.916,0.297,1.877,0.485,2.885,0.485c1.012,0,1.979-0.188,2.889-0.485
	c0.162-0.051,0.332-0.078,0.5-0.078c3.025,0,5.625,1.723,6.951,4.221C25.354,29.172,21.643,31.049,17.5,31.049z"
        />
      </svg>
    );
  }
}
